<template>
    <div class="store-workbench">
        <div class="welcome-bar mb-8"><span>Hi，{{ supplier.supplierNameCn }}-{{ user.userName }}，欢迎回来！</span><el-button class="refresh-btn" @click="handleRefresh"><img :src="refreshImg" alt="刷新" size="mini" width="14" height="14"></el-button></div>
        <div class="car-box-part mb-8">
            <el-row :gutter="8">
                <el-col :span="18">
                    <el-row class="mb-8" :gutter="8">
                        <el-col :span="8">
                            <div class="card-box warning">
                                <div class="card-box-title">
                                    <span>预警待办</span>
                                    <img class="card-box-icon" :src="warningImg" size="mini" width="48" height="48">
                                </div>
                                <div class="card-box-content">
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-cw" @click="linkToPointPage(linkConfig.warningContract)">
                                            <span class="label">合同预警</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.contractWarningTaskCount }}</span></span>
                                        </div>
                                        <el-tooltip content="合同距离结束30天的数量" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-qw" @click="linkToPointPage(linkConfig.warningQlf)">
                                            <span class="label">资质预警</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.supplierDocumentWarningCount }}</span></span>
                                        </div>
                                        <el-tooltip content="业务类型=仓储、装卸。产生了资质预警" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-sw" @click="linkToPointPage(linkConfig.warningSalary)">
                                            <span class="label">工人发薪预警</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.workerSalaryConfirmCount }}</span></span>
                                        </div>
                                        <el-tooltip content="工资确认=未收到" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="card-box delegate">
                                <div class="card-box-title">
                                    <span>仓储委派函</span>
                                    <img class="card-box-icon" :src="delegateImg" size="mini" width="48" height="48">
                                </div>
                                <div class="card-box-content">
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-d-st" @click="linkToPointPage(linkConfig.delegateStart)">
                                            <span class="label">委派函待发起数</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.warehouseSignWaitStartCount }}</span></span>
                                        </div>
                                        <el-tooltip content="供应商签署状态=待发起" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-d-sg" @click="linkToPointPage(linkConfig.delegateSign)">
                                            <span class="label">待签订委派函数</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.warehouseSignWaitSignCount }}</span></span>
                                        </div>
                                        <el-tooltip content="仓库人员签署状态=未签署、已撤回、签署失败" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-d-ad" @click="linkToPointPage(linkConfig.delegateAudit)">
                                            <span class="label">委派函待审批数</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.warehouseSignAuditCount }}</span></span>
                                        </div>
                                        <el-tooltip content="审批状态=待审批、审批中、驳回、撤回" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="card-box performance">
                                <div class="card-box-title">
                                    <span>绩效整改</span>
                                    <img class="card-box-icon" :src="performanceImg" size="mini" width="48" height="48">
                                </div>
                                <div class="card-box-content">
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-p-ad" @click="linkToPointPage(linkConfig.performAdjust)">
                                            <span class="label">整改</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.rectificationCount }}</span></span>
                                        </div>
                                        <el-tooltip content="运作质量=整改" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-p-ta" @click="linkToPointPage(linkConfig.performView)">
                                            <span class="label">整改约谈</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.rectificationInterviewCount }}</span></span>
                                        </div>
                                        <el-tooltip content="运作质量=整改约谈" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                    <div class="card-box-content-item-wrap">
                                        <div class="card-box-content-item bigData-btn-p-rs" @click="linkToPointPage(linkConfig.performRisk)">
                                            <span class="label">运作风险</span>
                                            <span class="value-wrap"><span class="value">{{ boardInfo.operationalRiskCount }}</span></span>
                                        </div>
                                        <el-tooltip content="运作质量=运作风险" placement="top">
                                            <img :src="infoImg" width="16">
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="16">
                            <div class="card-box finance">
                                <div class="card-box-title">
                                    <span>财务待办</span>
                                    <img class="card-box-icon" :src="financeImg" size="mini" width="48" height="48">
                                </div>
                                <div class="card-box-content">
                                    <el-row>
                                        <el-col :span="12">
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-fe" @click="linkToPointPage(financialToDoConfig.checkFee.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.checkFee.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.checkFee.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.checkFee.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-ap" @click="linkToPointPage(financialToDoConfig.settlementApply.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.settlementApply.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.settlementApply.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.settlementApply.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-cg" @click="linkToPointPage(financialToDoConfig.dealingsCheckBill.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.dealingsCheckBill.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.dealingsCheckBill.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.dealingsCheckBill.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-bi" @click="linkToPointPage(financialToDoConfig.checkBill.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.checkBill.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.checkBill.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.checkBill.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-ti" @click="linkToPointPage(financialToDoConfig.invoiceManagement.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.invoiceManagement.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.invoiceManagement.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.invoiceManagement.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                            <div class="card-box-content-item-wrap">
                                                <div class="card-box-content-item bigData-btn-b-nt" @click="linkToPointPage(financialToDoConfig.noTaxDebtProof.pageParams)">
                                                    <span class="label">{{ financialToDoConfig.noTaxDebtProof.label }}</span>
                                                    <span class="value-wrap"><span class="value">{{ financialToDoConfig.noTaxDebtProof.value }}</span></span>
                                                </div>
                                                <el-tooltip :content="financialToDoConfig.noTaxDebtProof.desc" placement="top">
                                                    <img :src="infoImg" width="16">
                                                </el-tooltip>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="card-box resource">
                                <div class="card-box-title">
                                    <span>需求资源</span>
                                    <img class="card-box-icon" :src="resourceImg" size="mini" width="48" height="48">
                                </div>
                                <div class="card-box-content">
                                    即将上线，敬请期待
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="6">
                    <DeskNotice
                        :noticeData="noticeData"
                        @on-all-detail="onAllNoticeDetail"
                    />
                </el-col>
            </el-row>
        </div>
        <TabPane ref="tabRef" class="mb-8"/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import refreshImg from './img/refresh.png'
import warningImg from './img/icon_warning.png'
import delegateImg from './img/icon_delegate.png'
import performanceImg from './img/icon_performance.png'
import financeImg from './img/icon_finance.png'
import resourceImg from './img/icon_resource.png'
import infoImg from './img/info_outline.png'
import DeskNotice from './DeskNotice.vue'
import TabPane from './tabPane.vue'
import { setFinancialToDoNum, financialToDoConfig } from './bmsFinancialToDo.js';
import {
    warningQuantity,
    delegateQuantity,
    performanceQuantity,
    supplierNoticeHomePage,
} from './manageDaskApi.js';

const linkConfig = {
    warningContract: {
        path: '/lsrm/contractSigning',
        query: {}
    },
    warningQlf: {
        path: '/lsrm/basicInfo',
        query: {}
    },
    warningSalary: {
        path: '/lsrm/loaderSalaryConfirm',
        query: {
            confirmStatusList: '3' // 工资确认：未收到
        }
    },
    delegateStart: {
        path: '/lsrm/warehouseDelegationLetter',
        query: {
            supplierSignStatusList: '2' // 供应商签署状态: 待发起
        }
    },
    delegateSign: {
        path: '/lsrm/warehouseDelegationLetter',
        query: {
            warehouseWorkerSignStatusList: '-1,0,3' // 仓库人员签署状态: 未签署0、已撤回3、签署失败-1
        }
    },
    delegateAudit: {
        path: '/lsrm/warehouseDelegationLetter',
        query: {
            auditStatusList: '2,3,30,80' // 审批状态：待审批2、审批中3、驳回30、撤回80
        }
    },
    performAdjust: {
        path: '/lsrm/performanceAdjustment',
        query: {
            recalculateOperationalQualityList: '2' // 运作质量: 整改
        }
    },
    performView: {
        path: '/lsrm/performanceAdjustment',
        query: {
            recalculateOperationalQualityList: '3' // 运作质量: 整改约谈
        }
    },
    performRisk: {
        path: '/lsrm/performanceAdjustment',
        query: {
            recalculateOperationalQualityList: '5' // 运作质量: 运作风险
        }
    }
}

export default {
    components: { DeskNotice, TabPane},
    provide() {
        return {
            linkToPointPage: this.linkToPointPage
        };
    },
    data() {
        return {
            refreshImg,
            warningImg,
            delegateImg,
            performanceImg,
            financeImg,
            resourceImg,
            infoImg,
            authLinkList: [],
            boardInfo: {
                contractWarningTaskCount: '-',
                supplierDocumentWarningCount: '-',
                workerSalaryConfirmCount: '-',
                warehouseSignWaitStartCount: '-',
                warehouseSignWaitSignCount: '-',
                warehouseSignAuditCount: '-',
                rectificationCount: '-',
                rectificationInterviewCount: '-',
                operationalRiskCount: '-',
            },
            linkConfig,
            noticeData: {
                // code: 'bidNotice',
                // isRemove: true,
                // label: '招标公告',
                // type: 'notice',
                totalCount: 0,
                // auth: '/index-srm-120',
                childList: [
                    // {
                    //     id: "1",
                    //     noticeCode: "1",
                    //     noticeTitle: "",
                    //     updateTime: "2023-01-01 16:31:46",
                    //     recommendFlag: true,
                    //     readFlag: true
                    // }
                ]
            },
            // 财务待办统计数配置
            financialToDoConfig
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'supplier',
            // 'currentTenant',
            // 'menus',
            'btnPermissions',
            'authority'
        ]),
    },
    methods: {
        findValueRecursive(arr, allList) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i]['resourceType'] === 2) {
                    allList.push(arr[i]['frontUrl']);
                } else if (Array.isArray(arr[i]['subResources'])) {
                    const result = this.findValueRecursive(
                        arr[i]['subResources'],
                        allList
                    ); // 递归查找
                    if (result) return result; // 如果找到，返回结果
                }
            }
            return null; // 没有找到匹配的对象，返回null
        },
        linkToPointPage(page) {
            if (!this.authLinkList.includes(page.path)) {
                this.$message.warning('您无对应菜单权限，无法访问！');
                return;
            }
            setTimeout(() => {
                this.$router.push({
                    path: page.path,
                    query: page.query
                });
            }, 0);
        },
        // 加载预警待办、仓储委派函、绩效整改数据
        loadBoardData() {
            if (this.btnPermissions.includes('/storeWorkbench-10')) {
                warningQuantity().then(res => {
                    if (res && +res.code === 0) {
                        this.boardInfo.contractWarningTaskCount = res.data.contractWarningTaskCount
                        this.boardInfo.supplierDocumentWarningCount = res.data.supplierDocumentWarningCount
                        this.boardInfo.workerSalaryConfirmCount = res.data.workerSalaryConfirmCount
                    }
                })
            } else {
                this.boardInfo.contractWarningTaskCount = 0
                this.boardInfo.supplierDocumentWarningCount = 0
                this.boardInfo.workerSalaryConfirmCount = 0
            }
            
            if (this.btnPermissions.includes('/storeWorkbench-20')) {
                delegateQuantity().then(res => {
                    if (res && +res.code === 0) {
                        this.boardInfo.warehouseSignWaitStartCount = res.data.warehouseSignWaitStartCount
                        this.boardInfo.warehouseSignWaitSignCount = res.data.warehouseSignWaitSignCount
                        this.boardInfo.warehouseSignAuditCount = res.data.warehouseSignAuditCount
                    }
                })
            } else {
                this.boardInfo.warehouseSignWaitStartCount = 0
                this.boardInfo.warehouseSignWaitSignCount = 0
                this.boardInfo.warehouseSignAuditCount = 0
            }

            if (this.btnPermissions.includes('/storeWorkbench-30')) {
                performanceQuantity().then(res => {
                    if (res && +res.code === 0) {
                        this.boardInfo.rectificationCount = res.data.rectificationCount
                        this.boardInfo.rectificationInterviewCount = res.data.rectificationInterviewCount
                        this.boardInfo.operationalRiskCount = res.data.operationalRiskCount
                    }
                })
            } else {
                this.boardInfo.rectificationCount = 0
                this.boardInfo.rectificationInterviewCount = 0
                this.boardInfo.operationalRiskCount = 0
            }
        },
        // 公告列表
        getSupplierNoticeHomePage() {
            if (!this.btnPermissions.includes('/storeWorkbench-60')) {
                this.noticeData.totalCount = 0
                this.noticeData.childList = []
                return
            }
            const params = {
                pageNo: 1,
                pageSize: 30,
                supplierCode: this.supplier.supplierCode
            };
            let dataList = [];
            let totalCountVal = 0;
            supplierNoticeHomePage(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list, totalCount } = res.data;
                        totalCountVal = totalCount || 0;
                        if (Array.isArray(list)) {
                            dataList = list;
                        }
                    }
                })
                .finally(() => {
                    this.noticeData.totalCount = totalCountVal;
                    this.noticeData.childList = dataList;
                });
        },
        onAllNoticeDetail() {
            const pageParams = {
                path: '/lsrm/supAnnoList',
                query: {}
            };
            this.linkToPointPage(pageParams);
        },
        setDataList() {},
        handleRefresh() {
            this.loadBoardData()
            this.getSupplierNoticeHomePage()
            setFinancialToDoNum(this.financialToDoConfig);
            this.$refs.tabRef.freshData()
        },
    },
    mounted() {
        if (Array.isArray(this.authority)) {
            const allList = [];
            this.findValueRecursive(this.authority, allList);
            this.authLinkList = allList;
        }
        this.loadBoardData()
        this.getSupplierNoticeHomePage();
        setFinancialToDoNum(this.financialToDoConfig);
    },
}
</script>
<style lang="less">
.store-workbench {
    min-width: 1216px;

    .mb-8 {
        margin-bottom: 8px;
    }

    .welcome-bar {
        padding-left: 24px;
        padding-right: 24px;
        height: 50px;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1D2129;
        background-image: url('./img/bar_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .refresh-btn {
        border-radius: 3px;
        border: 1px solid #C0C5CF;
        background: #fff;
        padding: 9px;

        &:hover {
            background: #F2F3F5;
        }

        &:focus {
            background: #E5E6EB;
        }
    }

    .car-box-part {
        overflow: hidden;
    }

    .card-box {
        padding: 24px;
        border-radius: 4px;
        color: #1D2129;
        box-sizing: border-box;

        &.warning {
            background: linear-gradient(180deg, #FFECE8 0%, #FFFFFF 13%, #FFFFFF 100%);
        }

        &.delegate {
            background: linear-gradient(180deg, #E0F5EB 0%, #FFFFFF 13%, #FFFFFF 100%);
        }

        &.performance {
            background: linear-gradient(180deg, #ECE1FE 0%, #FFFFFF 13%, #FFFFFF 100%);
        }

        &.finance {
            background: linear-gradient(180deg, #FFF3E3 0%, #FFFFFF 13%, #FFFFFF 100%);
        }

        &.resource {
            background: linear-gradient(180deg, #EFF0F3 0%, #FFFFFF 13%, #FFFFFF 100%);
            height: 216px;
            .card-box-title, .card-box-content {
                color: #C0C5CF;
            }
        }
    }

    .card-box-title {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1D2129;
        margin-bottom: 16px;
        position: relative;

        img {
            position: absolute;
            top: 0;
            right: 0;
        }
    }

    .card-box-content-item-wrap {
        display: flex;
        align-items: center;
        & + .card-box-content-item-wrap {
            margin-top: 16px;
        }
    }

    .card-box-content-item {
        padding: 6px 12px;
        margin-right: 8px;
        min-width: 156px;
        width: 70%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F7F8FA;
        border-radius: 2px;
        border: 1px solid #F7F8FA;
        box-sizing: border-box;

        .value-wrap {
            display: flex;
            align-items: baseline;
        }

        &:hover {
            cursor: pointer;
            background: #E5F0FF;
            border: 1px solid #2881FF;

            .value-wrap::after {
                content: '';
                margin-left: 7px;
                width: 6px;
                height: 10px;
                background: url(./img/arrow-right.png) no-repeat;
                display: inline-block;
                background-size: 100% 100%;
                vertical-align: middle;
            }
        }


        .label {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 400;
            color: #4E5969;
            white-space: nowrap;
        }

        .value {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #1D2129;
            display: inline-block;
            max-width: 35px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
    }
}
</style>
